import { IsVarEmpty } from './GlobalFunctions'

export const isJSONString = (str: Nullable<string>): boolean => {
    if (IsVarEmpty(str)) return false

    try {
        JSON.parse(str)
        return true
    } catch (_) {
        return false
    }
}
